import axiosInstance from "api/axios";

export const authService = {
  login: async (email: string, password: string) => {
    const response = await axiosInstance.post("/auth/login", {
      email,
      password,
    });
    return response.data;
  },
  getCurrentUser: async () => {
    const response = await axiosInstance.get("/user/me");
    return response.data;
  },
  updateProfile: async (id: number, data: FormData) => {
    const response = await axiosInstance.put(`/user/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
};
